import React from 'react';
import { css } from '@emotion/react';

import CarrierOnboarding from './components/CarrierOnboarding';
import ShipperOnboarding from './components/ShipperOnboarding';

/**
 * The Accounts page's Onboarding view, the parent for both account kinds: carrier or shipper onboarding.
 *
 * @param {{ kind: 'carrier'|'shipper', search: string }} props
 */
const OnboardingView = ({ kind, search }) => (
    // The wrapper stays bare: `.onward-design .flex` matches descendants only.
    <div
        className="onward-design"
        css={css`
            display: flex;
            flex: 1;
            min-height: 0;
            width: 100%;
        `}
    >
        <div className="flex min-h-0 w-full flex-1">
            {kind === 'carrier' ? <CarrierOnboarding search={search} /> : <ShipperOnboarding search={search} />}
        </div>
    </div>
);

export default OnboardingView;
